<div class="contenido">
  <div class="indicators-container">
    <div class="indicators">
      <span class="subtitle-card text-color-primary-1 text-weight-600 text-size-16">
        {{properties?.category}}
      </span>
      <span class="subtitle-card text-color-white text-weight-400 text-size-12">
        Categoría
      </span>
    </div>
    <div class="indicators">
      <span class="subtitle-card text-color-primary-1 text-weight-600 text-size-16">
        {{properties?.subcategory}}
      </span>
      <span class="subtitle-card text-color-white text-weight-400 text-size-12">
        Subcategoría
      </span>
    </div>
    <div class="indicators">
      <span class="subtitle-card text-color-primary-1 text-weight-600 text-size-16">
        {{properties?.priority}}
      </span>
      <span class="subtitle-card text-color-white text-weight-400 text-size-12">
        Prioridad
      </span>
    </div>
    <div class="indicators">
      <span class="subtitle-card text-color-primary-1 text-weight-600 text-size-16">
        {{properties?.postalcode}}
      </span>
      <span class="subtitle-card text-color-white text-weight-400 text-size-12">
        Código postal
      </span>
    </div>
  </div>

  <div class="body-content">
    <span class="subtitle-card text-weight-500 text-size-16">
      Usuario: {{properties?.observationsAuthor?.substring(0, properties?.observationsAuthor?.indexOf('@'))}} <br>
      {{properties?.observations}}
    </span>
  </div>

  <div class="indicators-container">
    <div class="indicators-bottom">
      <span class="subtitle-card text-color-secondary-1 text-weight-600 text-size-14">
        {{properties?.eventDate | date:'dd/MM/yyyy • hh:mm' }}
      </span>
      <span class="subtitle-card text-color-white text-weight-400 text-size-14">
        Fecha y hora <br>de la situación
      </span>
    </div>
    <div class="indicators-bottom">
      <span class="subtitle-card text-color-secondary-1 text-weight-600 text-size-14">
        {{properties?.creationDate | date:'dd/MM/yyyy • hh:mm' }}
      </span>
      <span class="subtitle-card text-color-white text-weight-400 text-size-14">
        Fecha y hora <br>de creación
      </span>
    </div>
    <div class="indicators-bottom">
      <span class="subtitle-card text-color-secondary-1 text-weight-600 text-size-14">
        {{properties?.status}}
      </span>
      <span class="subtitle-card text-color-white text-weight-400 text-size-14">
        Estado
      </span>

    </div>
    <div class="indicators-bottom">
      <span class="subtitle-card text-color-secondary-1 text-weight-600 text-size-14">
        {{properties?.source}}
      </span>
      <span class="subtitle-card text-color-white text-weight-400 text-size-14">
        Fuente
      </span>
    </div>
  </div>
</div>